import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import { determineHighestNumberFactory } from 'components/Comparison/LineItems/helpers';
// eslint-disable-next-line import/no-cycle
import {
  LineItemContainer,
  LineItem,
  LineItemValue,
} from 'components/Comparison/LineItems';

const formatFuelCost = (vehicle) => {
  if (vehicle.annual_fuel_cost) {
    return numeral(vehicle.annual_fuel_cost).format('$0,0');
  }
  return 'N/A';
};

function determineLowestAnnualCost({ vehicle1, vehicle2 }) {
  if (!vehicle1.annual_fuel_cost || !vehicle2.annual_fuel_cost) {
    return null;
  }

  if (vehicle1.annual_fuel_cost < vehicle2.annual_fuel_cost) {
    return vehicle1;
  }
  if (vehicle2.annual_fuel_cost < vehicle1.annual_fuel_cost) {
    return vehicle2;
  }
  return null;
}

export default function CostOfOwnership({ comparison }) {
  const { t } = useTranslation();

  const formatFuelCostBreakdown = (vehicle) => {
    if (vehicle.current_gas_price) {
      return t('comparison.lineItems.costOfOwnership.breakdown', {
        currentGasPrice: vehicle.current_gas_price,
      });
    }
    return null;
  };

  function formatMpgFactory(field) {
    return (vehicle) => {
      if (vehicle[field]) {
        return t('comparison.lineItems.costOfOwnership.mpg', {
          mpg: vehicle[field],
        });
      }
      return 'N/A';
    };
  }
  return (
    <LineItemContainer
      title={t('comparison.lineItems.costOfOwnership.header')}
      comparison={comparison}
    >
      <LineItem title={t('comparison.lineItems.costOfOwnership.fuelCosts')}>
        <LineItemValue
          comparison={comparison}
          getValue={formatFuelCost}
          getSubText={formatFuelCostBreakdown}
          determineWinner={determineLowestAnnualCost}
        />
      </LineItem>
      <LineItem title={t('comparison.lineItems.costOfOwnership.fuelEconomy')}>
        <LineItemValue
          comparison={comparison}
          getValue={formatMpgFactory('city_mpg')}
          getSubText={() => t('comparison.lineItems.costOfOwnership.city')}
          determineWinner={determineHighestNumberFactory('city_mpg')}
        />
        <LineItemValue
          comparison={comparison}
          getValue={formatMpgFactory('highway_mpg')}
          getSubText={() => t('comparison.lineItems.costOfOwnership.highway')}
          determineWinner={determineHighestNumberFactory('highway_mpg')}
        />
      </LineItem>
    </LineItemContainer>
  );
}

CostOfOwnership.propTypes = {
  comparison: PropTypes.object,
};
